import { createSlice } from '@reduxjs/toolkit';
import {
  createAddress,
  fetchListAddress,
  fetchProvinces,
  fetchWards,
} from '../actions/address.action';

const initialState = {
  provinces: {
    isLoading: false,
    isNeedReloadData: true,
    data: [],
  },
  wards: {
    isLoading: false,
    isNeedReloadData: true,
    data: [],
  },
  listAddress: {
    isLoading: false,
    isNeedReloadData: true,
    data: [],
  },
};

export const addressReducer = createSlice({
  name: 'Address',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchProvinces.pending, state => {
        state.provinces = {
          ...state.provinces,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchProvinces.fulfilled, (state, action) => {
        state.provinces = {
          ...state.provinces,
          isLoading: false,
          data: action.payload?.data || [],
        };
      })
      .addCase(fetchWards.pending, state => {
        state.wards = {
          ...state.wards,
          data: [],
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchWards.fulfilled, (state, action) => {
        state.wards = {
          ...state.wards,
          isLoading: false,
          data: [...(action.payload?.data || [])],
        };
      })
      .addCase(fetchListAddress.pending, state => {
        state.listAddress = {
          ...state.listAddress,
          data: [],
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchListAddress.fulfilled, (state, action) => {
        state.listAddress = {
          ...state.listAddress,
          isLoading: false,
          data: [...(action.payload?.data || [])],
        };
      })
      .addCase(createAddress.pending, state => {
        state.listAddress = {
          ...state.listAddress,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(createAddress.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.listAddress = {
            ...state.listAddress,
            isLoading: false,
            data: [...state.listAddress.data, { ...action.payload?.data }],
          };
        } else {
          state.listAddress = {
            ...state.listAddress,
            isLoading: false,
          };
        }
      });
  },
});
export default addressReducer.reducer;
